// extracted by mini-css-extract-plugin
export var container = "_a6-0";
export var icon = "_a6-1";
export var text = "_a6-2";